import { render, staticRenderFns } from "./RegistroAsistencia.vue?vue&type=template&id=f6c47c1c&"
import script from "./RegistroAsistencia.vue?vue&type=script&lang=js&"
export * from "./RegistroAsistencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports